import React, {useEffect, useRef, useState} from 'react';
import classNames from "classnames";

const formatTo12Hour = (time) => {
    const [hours, minutes] = time.split(':');
    const h = parseInt(hours, 10);
    const suffix = h >= 12 ? 'PM' : 'AM';
    const hour12 = h % 12 === 0 ? 12 : h % 12;
    return `${hour12}:${minutes} ${suffix}`;
};

const TimeSlotGrid = ({slots, bookedSlots, onSelect, selectedTime, ...props}) => {
    const scrollRef = useRef(null);
    const [showTopFade, setShowTopFade] = useState(false);
    const [showBottomFade, setShowBottomFade] = useState(false);
    let radius = '0';

    useEffect(() => {
        if (!props.pageRef?.current) return;
        radius = getComputedStyle(props.pageRef.current)?.getPropertyValue('--container-roundness');
    }, [props.pageRef]);

    const handleScroll = () => {
        const el = scrollRef.current;
        if (!el) return;

        setShowTopFade(el.scrollTop > 5);
        setShowBottomFade(el.scrollHeight - el.scrollTop > el.clientHeight + 5);
    };

    useEffect(() => {
        handleScroll(); // initialize on mount
    }, [slots]);

    return (
        <div className="relative">
            {/* Scrollable container */}
            <div
                ref={scrollRef}
                onScroll={handleScroll}
                className="h-[250px] overflow-y-auto flex flex-col gap-2 pr-1 relative z-10"
            >
                {slots.map((time) => {
                    const isBooked = bookedSlots.includes(time);
                    return (
                        <button
                            key={time}
                            onClick={(e) => !isBooked && onSelect(e, time)}
                            disabled={isBooked}
                            style={{borderRadius: radius === '0px' ? '0' : ''}}
                            className={classNames(
                                "w-full text-left px-4 py-2 text-sm font-medium rounded-theme transition-all duration-200 border",
                                isBooked
                                    ? 'bg-gray-200 text-gray-400 cursor-not-allowed border-gray-200'
                                    : selectedTime === time
                                        ? 'bg-light border-base'
                                        : 'bg-white hover:border-base'
                            )}
                        >
                            {formatTo12Hour(time)}
                        </button>
                    );
                })}
            </div>

            {/* Conditional gradient overlays */}
            {showTopFade && (
                <div
                    className="pointer-events-none absolute inset-x-0 top-0 h-6 bg-gradient-to-b from-white to-transparent z-20"/>
            )}
            {showBottomFade && (
                <div
                    className="pointer-events-none absolute inset-x-0 bottom-0 h-6 bg-gradient-to-t from-white to-transparent z-20"/>
            )}
        </div>
    );
};

export default TimeSlotGrid;
